<script lang="ts">
  import { icon, type IconDefinition } from '@fortawesome/fontawesome-svg-core'

  let { icon: definition }: { icon: IconDefinition } = $props()
</script>

{@html icon(definition).html[0]}
